import React, { useEffect, useState } from 'react';
import Icons from './Icons';

const slides = [
	{
		id: 1,
		title: 'Compra y Venta de ',
		highlight: 'Minerales',
		description: 'Con laboratorio certificado, trazabilidad de lotes y evaluacion tecnica para operaciones seguras.',
		image: 'https://images.unsplash.com/photo-1518546305927-5a555bb7020d?auto=format&fit=crop&w=1600&q=80',
		tag: 'Mercado mayorista',
	},
	{
		id: 2,
		title: 'Analisis de ',
		highlight: 'Laboratorio',
		description: 'Ensayes, control de pureza y reportes confiables para exportacion, refineria y abastecimiento industrial.',
		image: 'https://images.unsplash.com/photo-1581092918056-0c4c3acd3789?auto=format&fit=crop&w=1600&q=80',
		tag: 'Resultados certificados',
	},
	{
		id: 3,
		title: 'Logistica y ',
		highlight: 'Despacho',
		description: 'Coordinamos embarques, pesaje y seguimiento comercial para cada entrega de concentrados y minerales.',
		image: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?auto=format&fit=crop&w=1600&q=80',
		tag: 'Cobertura nacional',
	},
];

export default function Hero() {
	const [activeSlide, setActiveSlide] = useState(0);

	useEffect(() => {
		const intervalId = window.setInterval(() => {
			setActiveSlide((currentSlide) => (currentSlide + 1) % slides.length);
		}, 5000);

		return () => window.clearInterval(intervalId);
	}, []);

	const goToPreviousSlide = () => {
		setActiveSlide((currentSlide) => (currentSlide === 0 ? slides.length - 1 : currentSlide - 1));
	};

	const goToNextSlide = () => {
		setActiveSlide((currentSlide) => (currentSlide + 1) % slides.length);
	};

	return (
		<section id="inicio" className="relative overflow-hidden bg-slate-950 text-white">
			<div className="absolute inset-0">
				{slides.map((slide, index) => (
					<div
						key={slide.id}
						className={`absolute inset-0 bg-cover bg-center transition-all duration-700 ${
							index === activeSlide ? 'scale-100 opacity-100' : 'scale-105 opacity-0'
						}`}
						style={{ backgroundImage: `url(${slide.image})` }}
						aria-hidden={index !== activeSlide}
					/>
				))}
				<div className="absolute inset-0 bg-slate-950/65" />
				<div className="absolute inset-0 bg-gradient-to-r from-slate-950 via-slate-950/70 to-mineral-950/40" />
				<div className="absolute left-[-10%] top-10 h-56 w-56 rounded-full bg-gold-500/20 blur-3xl" />
				<div className="absolute bottom-0 right-[-8%] h-72 w-72 rounded-full bg-mineral-400/20 blur-3xl" />
			</div>

			<div className="relative mx-auto grid min-h-[540px] max-w-7xl gap-10 px-4 py-20 lg:grid-cols-[1.2fr_0.8fr] lg:items-center">
				<div className="max-w-3xl">
					<span className="glass inline-flex items-center gap-2 rounded-full px-4 py-2 text-sm font-medium text-mineral-100">
						<span className="h-2 w-2 rounded-full bg-gold-400" />
						{slides[activeSlide].tag}
					</span>

					<h1 className="mt-6 text-4xl font-extrabold leading-tight sm:text-5xl lg:text-6xl">
						{slides[activeSlide].title}
						<span className="gradient-text">{slides[activeSlide].highlight}</span>
					</h1>

					<p className="mt-5 max-w-2xl text-lg text-slate-200 sm:text-xl">
						{slides[activeSlide].description}
					</p>

					<div className="mt-8 flex flex-col gap-4 sm:flex-row">
						<a
							href="#contacto"
							className="inline-flex items-center justify-center gap-2 rounded-full bg-mineral-500 px-6 py-3 font-semibold text-white shadow-lg shadow-mineral-900/40 transition hover:bg-mineral-400"
						>
							Solicitar cotizacion
							<Icons.ArrowRight />
						</a>
						<a
							href="#minerales"
							className="inline-flex items-center justify-center gap-2 rounded-full border border-white/20 bg-white/10 px-6 py-3 font-semibold text-white transition hover:bg-white/15"
						>
							Ver minerales
							<span className="rotate-90">
								<Icons.ChevronRight />
							</span>
						</a>
					</div>

					<div className="mt-10 grid gap-4 sm:grid-cols-3">
						<div className="glass rounded-2xl p-4">
							<div className="mb-3 flex h-12 w-12 items-center justify-center rounded-2xl bg-mineral-400/20 text-mineral-100">
								<Icons.Scale />
							</div>
							<p className="font-semibold">Pesaje y control</p>
							<p className="mt-1 text-sm text-slate-300">Verificacion por lote y despacho.</p>
						</div>
						<div className="glass rounded-2xl p-4">
							<div className="mb-3 flex h-12 w-12 items-center justify-center rounded-2xl bg-gold-400/20 text-gold-400">
								<Icons.Flask />
							</div>
							<p className="font-semibold">Ensaye certificado</p>
							<p className="mt-1 text-sm text-slate-300">Analisis tecnico con soporte documental.</p>
						</div>
						<div className="glass rounded-2xl p-4">
							<div className="mb-3 flex h-12 w-12 items-center justify-center rounded-2xl bg-copper-400/20 text-copper-400">
								<Icons.Shield />
							</div>
							<p className="font-semibold">Operacion segura</p>
							<p className="mt-1 text-sm text-slate-300">Trazabilidad comercial y cumplimiento.</p>
						</div>
					</div>
				</div>

				<div className="flex items-end justify-end">
					<div className="glass w-full max-w-md rounded-[32px] p-5 shadow-2xl shadow-slate-950/40">
						<div className="overflow-hidden rounded-[24px] border border-white/10 bg-slate-950/40">
							<img
								src={slides[activeSlide].image}
								alt={slides[activeSlide].highlight}
								className="h-72 w-full object-cover"
							/>
						</div>

						<div className="mt-5 flex items-center justify-between">
							<div>
								<p className="text-sm uppercase tracking-[0.3em] text-slate-300">Slide activo</p>
								<p className="mt-2 text-2xl font-bold">
									0{activeSlide + 1}
									<span className="text-base font-medium text-slate-400"> / 0{slides.length}</span>
								</p>
							</div>

							<div className="flex gap-3">
								<button
									type="button"
									onClick={goToPreviousSlide}
									className="flex h-12 w-12 items-center justify-center rounded-full border border-white/20 bg-white/10 transition hover:bg-white/20"
									aria-label="Diapositiva anterior"
								>
									<span className="rotate-180">
										<Icons.ChevronRight />
									</span>
								</button>
								<button
									type="button"
									onClick={goToNextSlide}
									className="flex h-12 w-12 items-center justify-center rounded-full bg-mineral-500 transition hover:bg-mineral-400"
									aria-label="Siguiente diapositiva"
								>
									<Icons.ChevronRight />
								</button>
							</div>
						</div>

						<div className="mt-5 flex gap-2">
							{slides.map((slide, index) => (
								<button
									key={slide.id}
									type="button"
									onClick={() => setActiveSlide(index)}
									className={`h-2 rounded-full transition-all ${
										index === activeSlide ? 'w-10 bg-gold-400' : 'w-3 bg-white/35 hover:bg-white/60'
									}`}
									aria-label={`Ir a la diapositiva ${index + 1}`}
								/>
							))}
						</div>
					</div>
				</div>
			</div>
		</section>
	);
}
